<template>
  <div id="dashboard">
    <div class="text_box">
      <div class="content">
        <div class="text_group">
          <div class="dashboard_button" @click="albumUpdate()">更新 Album</div>
          <div class="dashboard_button" @click="blogUpdate()">更新 Blog</div>
          <div class="loader_bar" v-show="loading">
            <img src="@/assets/img/loading_new.gif" alt="">
          </div>
          <h3>返回信息</h3>
          <div class="info">{{info}}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'dashboard',
  data () {
    return {
      loading: false,
      info: '还没有收到信息',
    }
  },
  created () {
    this.$store.dispatch('changeIndex', {linkName: 'dashboard'});
    this.$store.dispatch('isAdminLogin')
      .catch((err) => {
        this.$router.push({ name: 'login' });
      })
  },
  methods: {
    albumUpdate: function () {
      this.loading = true;
      this.$store.dispatch('post', {
        address: '/api/albumUpdate',
        postData: {},
      })
        .then((data) => {
          this.loading = false;
          if (data.status === 'OK') {
            this.info = data.info;
          } else {
            this.info = `Error: ${data.message}`;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.info = `Error: ${err.message}`;
        })
    },
    blogUpdate: function () {
      this.loading = true;
      this.$store.dispatch('post', {
        address: '/api/blogUpdate',
        postData: {},
      })
        .then((data) => {
          this.loading = false;
          if (data.status === 'OK') {
            this.info = data.info;
          } else {
            this.info = `Error: ${data.message}`;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.info = `Error: ${err.message}`;
        })
    },
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .text_box {
    margin: 30px 50px;
    padding: 10px;
    background-color: #F5F5F5;
    color: #5E5E5E;
  }
  .text_group {
    max-width: 600px;
    margin: 10px auto;
  }
  .content {
    line-height: 1.5em;
    max-width: 780px;
    margin: 40px auto;
  }
  .dashboard_button {
    background-color: #FFFFFF;
    font-size: 1.5em;
    margin: 20px 0;
    padding: 20px 10px;
    text-align: center;
    border: solid #cacaca;
    border-width: 1px;
    box-shadow: 0px 1px 3px rgba(0,0,0,.2);
    -webkit-box-shadow: 0px 1px 3px rgba(0,0,0,.2);
    cursor: pointer;
  }
  .loader_bar {
    background-color: #F5F5F5;
    position: relative;
    margin: 20px 20px 10px 20px;
    height: 60px;
    text-align: center;
  }
  .info {
    background-color: #FFFFFF;
    margin: 20px auto;
    padding: 10px;
    min-height: 100px;
    border: solid #cacaca;
    border-width: 1px;
  }
  @media screen and (max-width: 767px) {
    .text_box {
      margin: 30px 10px;
    }
    .content {
      margin: 20px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/dashboard.vue